<template>
  <v-dialog v-model="isOpen" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('ProfilePage.Form.header')}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row >
            <v-col cols="12">
              <v-text-field 
                v-model="password1"
                :type="showPassword1 ? 'text' : 'password'" 
                prepend-icon="lock" 
                :label="$t('LoginPage.Form.password')" 
                required 
                :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword1 = !showPassword1"
                @keyup.enter="changePassword"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field 
                v-model="password2"
                :type="showPassword2 ? 'text' : 'password'" 
                prepend-icon="lock" 
                :label="$t('LoginPage.Form.confirmPassword')" 
                :hint="$t('LoginPage.PasswordForm.help')" 
                required
                :rules="[passwordRule]"
                :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword2 = !showPassword2"
                @keyup.enter="changePassword"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn color="primary" :disabled="!same" @click="changePassword" :loading="sendingPassword">{{$t('ProfilePage.Button.applyChange')}}</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import meService from '@/services/me'
export default {
  name: 'UserPasswordFormModal',
  props: {
    show: {required: true, type: Boolean}
  },
  data () {
    return {
      showPassword1: false,
      showPassword2: false,
      password1: '',
      password2: '',
      sendingPassword: false
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.show
      },
      set() {
        this.close()
      }
    },
    same () {
      return this.password1 === this.password2
    },
    passwordRule () {
      return this.same || this.$t('LoginPage.PasswordForm.notSame')
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async changePassword () {
      if (this.same) {
        this.sendingPassword = true

        try {
          await meService.updatePassword(this.password1)
        } catch (error) {
          this.sendingPassword = false
          this.$store.dispatch('successMessage', this.$t('ProfilePage.Error.passwordNotUpdated'))
          throw error
        }

        this.$store.dispatch('successMessage', this.$t('ProfilePage.Success.passwordUpdated'))
        this.reset()
        this.close()
      }
    },
    reset () {
      this.password1 = ''
      this.password2 = ''
      this.showPassword1 = false
      this.showPassword2 = false
      this.sendingPassword = false
    }
  }
}
</script>
